import { memo, ReactNode, useRef, useState } from "react"
import Button from "../Button"

import './index.scss'
import { useClickOutside } from "../../hooks/useClickOutside"

type ButtonDropdown = {
  label: string | ReactNode
  content: string | ReactNode
}

const ButtonDropdown = memo(({
  label, content
}: ButtonDropdown) => {
  const dropdownRef = useRef()

  const [isOpen, setIsOpen] = useState<boolean>(false)

  useClickOutside(dropdownRef, () => setIsOpen(false))

  return (
    <div className="ButtonDropdown">
      <Button
        type="tertiary"
        size="s"
        isActive={isOpen}
        label={label}
        onClick={() => setIsOpen(!isOpen)}
      />
      {!!isOpen && (
        <div ref={dropdownRef} className={`ButtonDropdown__dropdown`}>
          {content}
        </div>
      )}
    </div>
  )
})

export default ButtonDropdown
